/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tools-wrap[_ngcontent-%COMP%]{\n  margin-top: 1.5rem;\n  padding: 0 .3rem;\n}\n\n.tools-wrap[_ngcontent-%COMP%]    > img[_ngcontent-%COMP%]{\n  width: 100%;\n}\n\n.tools-wrap[_ngcontent-%COMP%]   .tools-tips[_ngcontent-%COMP%]{\n  margin: .3rem 0;\n  font-size: .26rem;\n  font-weight: lighter;\n  color: #333333;\n  text-align: center;\n}\n\n.tools-wrap[_ngcontent-%COMP%]   .tools-tips[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{\n  font-size: .3rem;\n  font-weight: bold;\n  line-height: .5rem;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/app-tools/app-tools.component.css.shim.ngstyle.js.pre-build-optimizer.js